import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import React from 'react'

export const ReverseDialogV2 = (props: any) => {
  const {
    ID,
    openReverseDialog,
    setOpenReverseDialog,
    title,
    menu,
    handleReverse,
    passID,
  } = props

  return (
    <CommonDialog
      fullWidth
      open={openReverseDialog}
      onClose={() => setOpenReverseDialog(false)}
      sections={{
        header: {
          title: title,
          rightText: `Reverse`,
          infoLine: menu?.DocNo ?? menu?.Remark ?? menu?.obj?.Description,
        },
        body: () => (
          <div className="content-wrap full">
            <span
              style={{
                fontSize: '12px',
                lineHeight: '14px',
                fontWeight: 500,
              }}
            >
              {`Are you sure you want to Reverse this ${title ?? menu?.RefNo}?`}
            </span>
          </div>
        ),
        footer: {
          actions: [
            {
              displayText: 'Cancel',
              props: {
                onClick: () => setOpenReverseDialog(false),
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Confirm',
              props: {
                onClick: () => {
                  if (passID) {
                    handleReverse(ID)
                  } else {
                    handleReverse({ variables: ID })
                  }
                },
                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  )
}
